<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    d="M5.1 10.8H3V4.2h6.6v2.1H5.1v4.5ZM15 6.3V4.2h6.6v6.6h-2.1V6.3H15Zm-9.9 6.9H3v6.6h6.6v-2.1H5.1v-4.5Zm9.9 4.5h4.5v-4.5h2.1v6.6H15v-2.1Z"
    clip-rule="evenodd"
  /></svg
>
